import Marquee from "react-fast-marquee";

const WORDS = [
  "AI Governance", "Board Advisory", "Enterprise Risk", "Digital Transformation",
  "Fractional CIO", "Family Business", "Executive Advisory",
];

export const BrandMarquee = () => (
  <div data-testid="marquee" className="border-y border-[var(--line)] py-8 bg-[var(--paper-2)]">
    <Marquee speed={40} gradient={false}>
      {WORDS.map((w, i) => (
        <span key={i} className="marquee-item">
          {w} <span className="not-italic text-[var(--accent)]">✳</span>
        </span>
      ))}
    </Marquee>
  </div>
);
